import { render, staticRenderFns } from "./edros.vue?vue&type=template&id=cc6c82b4&scoped=true&"
import script from "./edros.vue?vue&type=script&lang=js&"
export * from "./edros.vue?vue&type=script&lang=js&"
import style0 from "./edros.vue?vue&type=style&index=0&id=cc6c82b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6c82b4",
  null
  
)

component.options.__file = "edros.vue"
export default component.exports